import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectors, actions } from '../store'

export const useCurrencies = () => {
  const dispatch = useDispatch()
  const currencies = useSelector(selectors.currencies.getCurrencies)

  useEffect(() => {
    dispatch(actions.currencies.getCurrencies({ disableRefetch: true }))
  }, [dispatch])

  return { currencies }
}
